import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureProductEvent } from "@/lib/analytics";
import { sanitizeTrackingSearch } from "@/lib/marketing-consent";
import { useConsent } from "@/hooks/useConsent";

export function usePageTracking() {
  const location = useLocation();
  const { isAllowed } = useConsent();
  const analyticsAllowed = isAllowed("analytics");
  const marketingAllowed = isAllowed("marketing");

  useEffect(() => {
    const sanitized = sanitizeTrackingSearch(location.search, {
      analyticsAllowed,
      marketingAllowed,
    });

    if (sanitized.changed) {
      const nextUrl = `${location.pathname}${sanitized.search}${location.hash}`;
      window.history.replaceState(window.history.state, "", nextUrl);
    }

    captureProductEvent("$pageview", {
      path: location.pathname,
      search: sanitized.search,
    });
  }, [analyticsAllowed, location.hash, location.pathname, location.search, marketingAllowed]);
}
